// 单例
const instanceTemp = (function instanceTemp() {
  let instance: any;

  return (newInstance: any) => {
    if (newInstance) { instance = newInstance; }
    return instance;
  };
}());

function createNode() {
  const node = document.createElement('div');
  node.setAttribute('style', `
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: none;
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0);
    color: #fff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
    z-index: 3888;
  `);

  const outerChildStyle = `
    position: absolute;
    top: 50%;
    left: 50%;
    width: 70px;
    height: 70px;
    margin-top: -35px;
    margin-left: -35px;
    background-color: rgba(0, 0, 0, .7);
    border-radius: 10px;
  `;

  const innerChildStyle = `
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -15px;
    margin-left: -15px;
    height: 26px;
    width: 26px;
    display: inline-block;
    border-radius: 999px;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    border: 2px solid #40CE9C;
    border-bottom-color: transparent;
    background-color: transparent;
    -webkit-animation: rotate 1.2s 0s linear infinite;
    animation: rotate 1.2s 0s linear infinite;
  `;
  node.innerHTML = `<div style="${outerChildStyle}">
    <div style="${innerChildStyle}"></div>
  </div>`;

  node.addEventListener('touchstart', (e) => {
    e.preventDefault();
  });

  return node;
}

function createStyle() {
  const style = document.createElement('style');

  style.innerText = `
        @-webkit-keyframes rotate {
            0% {-webkit-transform: rotate(0deg) scale(1);transform: rotate(0deg) scale(1);}
            50% {-webkit-transform: rotate(180deg) scale(1);transform: rotate(180deg) scale(1); }
            100% {-webkit-transform: rotate(360deg) scale(1);transform: rotate(360deg) scale(1); }
        }
    `;

  return style;
}

export default class AutoLoading {
  loadding: any;

  loadQueue: Array<any> = [];

  isWait = false

  constructor() {
    if (instanceTemp(null)) { return instanceTemp(null); }
    instanceTemp(this);

    this.loadding = createNode();
    this.loadQueue = [];

    /**
     * 是否等待隐藏标识, 超时之后清空
     * @type {Boolean}
     */
    this.isWait = false;

    document.body.appendChild(this.loadding);
    document.body.appendChild(createStyle());
  }

  show() {
    // 队里里面为0的时候, 开始阻止
    if (this.loadQueue.length === 0) {
      AutoLoading.preventDocumentDefault();
    }
    this.loadQueue.push(1);
    this.loadding.style.display = 'block';

    if (!this.isWait) { this.waitToHide(); }
  }

  waitToHide() {
    this.isWait = true;
    let timer = 0;

    clearTimeout(timer);

    // 隔5s如果还没反应请求成功就清空队列并隐藏
    timer = setTimeout(() => {
      clearTimeout(timer);

      this.loadQueue = [];
      this.end();
    }, 1000 * 30);
  }

  hide() {
    this.loadQueue.pop();

    if (this.loadQueue.length > 0) {
      return;
    }

    this.end();
  }

  end() {
    this.loadding.style.display = 'none';
    this.isWait = false;
    AutoLoading.removePrevent();
  }

  static returnFalse() {
    return false;
  }

  /**
   * 清除 页面中的默认事件 , 让你乱点
   */
  static preventDocumentDefault() {
    const { returnFalse } = AutoLoading;
    document.addEventListener('touchstart', returnFalse);
    document.addEventListener('touchmove', returnFalse);
    document.addEventListener('touchend', returnFalse);
  }

  static removePrevent() {
    const { returnFalse } = AutoLoading;
    document.removeEventListener('touchstart', returnFalse);
    document.removeEventListener('touchmove', returnFalse);
    document.removeEventListener('touchend', returnFalse);
  }
}
